import React from "react";

export default function Analytics() {
  return (
    <>
      <nav className="navbar bg-body-tertiary">
        <div className="container-fluid">
          <span className="navbar-brand mb-0 h1">Analytics</span>
        </div>
      </nav>
      <div dir="ltr" className="p-3">
        <p>This is the Analytics.</p>
      </div>
    </>
  );
}
